import { Pipe, PipeTransform, inject } from '@angular/core';
import { GenericApplicationSections } from '@shared/interfaces/agnostic-sections.type';
import { SectionsService } from '@app/shared/dasboard-sections/services/sections.service';

@Pipe({ name: 'sectionLocked', standalone: true, pure: false })
export class SectionLockedPipe implements PipeTransform {
  private readonly _sections = inject(SectionsService);

  transform(section: GenericApplicationSections): boolean {
    this._sections.ensureLockedSectionsLoaded();
    return this._sections.isSectionLocked(section);
  }
}
